"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _LazyBlur = _interopRequireDefault(require("./LazyBlur"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var LazyBlurImage = function LazyBlurImage(props) {
  var placeholder = props.placeholder,
      offset = props.offset,
      className = props.className,
      src = props.src,
      alt = props.alt;
  return /*#__PURE__*/_react.default.createElement(_LazyBlur.default, {
    offset: offset,
    placeholder: placeholder.src,
    placeholderWidth: placeholder.width,
    placeholderHeight: placeholder.height
  }, /*#__PURE__*/_react.default.createElement("img", {
    style: {
      width: "100%"
    },
    className: className,
    src: src,
    alt: alt
  }));
};

var _default = LazyBlurImage;
exports.default = _default;